import { useEffect, useState } from 'react';
import { decodeToken } from 'react-jwt';
import { useHistory, useLocation } from 'react-router-dom';

import { DASHBOARD } from '../constants/urls';
import {
  ExternalCustomer,
  useCheckExistingAccountByEmailQuery,
  useGetByAuth0IdLazyQuery,
} from '../gql/generated/graphql';
import { logout } from '../services/auth0';
import { EMAIL_KEY, JWTToken } from '../utils/auth';
import { CookieKeys, useCookie } from './useCookie';

const useAccountMenu = () => {
  const [customer, setCustomer] = useState<ExternalCustomer>();
  const [profileModalOpen, setProfileModalOpen] = useState(false);
  const [accessToken] = useCookie<string>(CookieKeys.ACCESS_TOKEN);
  const { [EMAIL_KEY]: email } = decodeToken<JWTToken>(accessToken ?? '') ?? {};

  const { data: hasAccount } = useCheckExistingAccountByEmailQuery({
    fetchPolicy: 'network-only',
    variables: { email: email ?? '' },
    skip: !email,
  });

  const { pathname } = useLocation();
  const history = useHistory();

  const [fetchCustomer] = useGetByAuth0IdLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      setCustomer(data?.getByAuth0Id as ExternalCustomer);
    },
  });

  useEffect(() => {
    if (hasAccount?.checkExistingAccountByEmail && email) {
      fetchCustomer();
      return;
    }
    setCustomer(undefined);
  }, [email, hasAccount?.checkExistingAccountByEmail, fetchCustomer]);

  return {
    customer,
    hasAccount: !!hasAccount?.checkExistingAccountByEmail,
    isOnDashboard: pathname === DASHBOARD,
    goToDashboard: () => history.push(DASHBOARD),
    handleLogout: () => logout(),
    profileModalOpen,
    setProfileModalOpen,
  };
};

export default useAccountMenu;
